import React, {useEffect, useState} from 'react';
import {Provider} from "react-redux";
import configure from "../../store/configure";

import * as apiUtil from "../../util/apiUtil";
import * as token from "../../util/tokenUtil";

import Loading from "../../component/loading/Loading";
import {aesDecrypt, aesEncrypt} from "../../util/aes256";

/**
 * kakao-sync switch page
 * */
const JoinSwitchPage = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    const state = JSON.parse(aesDecrypt(searchParams.get("state")));

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const platform = state.oauthType;

        const alimtalkRef = window.sessionStorage.getItem('alimtalkRef');
        if (alimtalkRef) window.sessionStorage.removeItem('alimtalkRef');

        const tokenUrl = `/api/auth/${platform.toLowerCase()}/token?code=${code}`
            + (alimtalkRef ? `&alimtalkRef=${encodeURIComponent(alimtalkRef)}` : '');

        apiUtil.asyncRequest({
            setLoading: setLoading,
            url: tokenUrl,
            method: apiUtil.requestMethod.POST,
            redirect_url: '/account/login',
            success: (result) => {
                if (result.accessToken && result.refreshToken) {
                    // 이미 가입한 사용자라면 로그인 프로세스 진행
                    token.setAccessToken(result.accessToken);
                    token.setRefreshToken(result.refreshToken);

                    // 유입 링크로 들어와 로그인이 필요한 목적지로 가려던 경우, 로그인 완료 후 그 페이지로 보낸다.
                    let redirect = "/";
                    try {
                        const pending = window.sessionStorage.getItem('postLoginRedirect');
                        if (pending) {
                            window.sessionStorage.removeItem('postLoginRedirect');
                            redirect = pending;
                        }
                    } catch (e) {
                        // sessionStorage 접근 불가 시 기본 목적지(/)로 진행한다.
                    }

                    window.location.href = redirect;
                } else {
                    const accessToken = result;

                    // 동의약관 조회
                    apiUtil.asyncRequest({
                        setLoading: setLoading,
                        url: `/api/auth/${platform.toLowerCase()}/agree`,
                        method: apiUtil.requestMethod.POST,
                        redirect_url: "/",
                        data: {
                            tokenOAuth: result,
                        },
                        success: (result) => {
                            const oState = aesEncrypt(JSON.stringify({
                                oAuthType: platform,
                                accessToken: accessToken
                            }))

                            let url = `/register/info`
                            url += `?oState=${encodeURIComponent(oState)}`;
                            url += `&jToken=${encodeURIComponent(result.tokenJoin)}`;
                            url += `&tMail=${result.termsMail}`;
                            url += `&tMms=${result.termsMms}`;
                            if (result.termsKakao) url += `&tKakao=${result.termsKakao}`;

                            window.location.href = url;
                        }
                    });
                }
            },
        });
    }, [code]);

    return (
        <Provider store={configure}>
            <Loading loading={loading} />
        </Provider>
    )
};

export default JoinSwitchPage;
